import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsPageFor } from './analyticsRoutePolicy';

let lastNavigationKey = null;

export function resetPageViewDedupeForTests() {
  lastNavigationKey = null;
}

export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const page = analyticsPageFor(location.pathname);
    if (!page || typeof window.gtag !== 'function') return;
    const navigationKey = `${location.key}:${location.pathname}:${location.search}`;
    if (lastNavigationKey === navigationKey) return;
    lastNavigationKey = navigationKey;
    document.title = page.title;
    window.gtag('event', 'page_view', {
      page_title: page.title,
      page_location: `${window.location.origin}${page.canonicalPath}`,
      page_path: page.canonicalPath,
      page_name: page.name,
    });
  }, [location.key, location.pathname, location.search]);

  return null;
}
